import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';

import { apiHost } from '../../../config';

import Question from '../../../types/Question';
import clamp from '../../../lib/clamp';
import { post } from '../../../lib/requests';

import Popup from '../../../components/common/ui/Popup/Popup';
import Radio from '../../../components/common/ui/Radio/Radio';
import ProgressBar from '../../../components/testing/ProgressBar/ProgressBar';

import styles from './QuestionPage.module.scss';

interface Props {
  questions: Question[];
}

const TestingQuestionPage = ({ questions }: Props) => {
  const [testingStartTime] = useState(Date.now());

  const history = useHistory();
  if (!sessionStorage.seenIntro) history.push('/testing/intro');

  const [answers, setAnswers] = useState<Record<number, number>>({});
  const [questionNumber, setQuestionNumber] = useState(0);
  const [selectedRadio, setSelectedRadio] = useState<number | undefined>(
    undefined,
  );

  const saveAnswer = (answer: number) => {
    if (answer === undefined) return;
    if (questions.length === 0) return;

    setAnswers((currentAnswers) => ({
      ...currentAnswers,
      [questions[questionNumber].id]: answer,
    }));
  };

  const nextQuestion = () => {
    if (selectedRadio === undefined) return;
    if (questions.length === 0) return;

    setSelectedRadio(undefined);
    setQuestionNumber((currentN: number) =>
      clamp(currentN + 1, 0, questions.length - 1),
    );
  };

  const submit = () => {
    const answersArray = Object.entries(answers).map(
      ([questionId, answer]) => ({ answer, questionId }),
    );

    post(`${apiHost}/api/testing/answers`, {
      answers: answersArray,
      duration: (Date.now() - testingStartTime ?? 0) / 1000,
    })
      .then(() => {
        alert('Ваши ответы сохранены');
        delete localStorage.token;
        delete sessionStorage.seenIntro;
        history.push('/login');
      })
      .catch((error) => alert(error.message));
  };

  return (
    <Popup width="900px" height="auto" className={styles.question_popup}>
      <ProgressBar
        marks={questions.map(({ id }) =>
          answers[id] !== undefined ? 'limegreen' : 'lightgray',
        )}
      />

      <h5 className="mb-5">
        Вопрос {questionNumber + 1} из {questions.length}
      </h5>

      <h4 className="mb-4" style={{ height: '100px' }}>
        {questions[questionNumber]?.text}
      </h4>

      <Form>
        <div className="mb-5">
          {Array.from(Array(10).keys()).map((_, i) => (
            <Radio
              // eslint-disable-next-line react/no-array-index-key
              key={`answer-${i}`}
              name={`answer-${i}`}
              label={`${i + 1}`}
              checked={i === selectedRadio}
              onChange={() => {
                if (selectedRadio !== undefined) return;
                setSelectedRadio(i);
                saveAnswer(i + 1);
              }}
            />
          ))}
        </div>

        <div className="d-flex justify-content-end">
          {questionNumber < questions.length - 1 ? (
            <Button
              variant="dark"
              type="submit"
              className="px-3"
              onClick={nextQuestion}
              disabled={selectedRadio === undefined}
            >
              Далее
            </Button>
          ) : (
            <Button
              variant="dark"
              type="button"
              className="px-3"
              onClick={submit}
              disabled={
                selectedRadio === undefined ||
                Object.keys(answers).length < questions.length
              }
            >
              Завершить тестирование
            </Button>
          )}
        </div>
      </Form>
    </Popup>
  );
};

export default TestingQuestionPage;
